<!-- BR#162 Sunny 17/03/2026 Implementing Google Authenticator -->
<template>
  <div v-if="visible" class="otp-modal">
    <div class="otp-container">

      <!-- Close Button -->
      <button class="close-btn" @click="closeModal">
        ✕
      </button>

      <h2>{{$t("two-factor-authentication")}}</h2>

      <!-- QR Code -->
      <div v-if="qrCodeStr" class="qr-section">
        <p>{{$t("scan-this-qr-with-google-authenticator")}}</p>
        <img :src="qrCodeStr" class="qr-image"/>
      </div>

      <!-- OTP Input -->


      <!-- Checkbox -->
      <div class="checkbox-section">
        <input type="checkbox" v-model="isConfirmed" id="confirmMFA">
        <label for="confirmMFA">
          {{$t("i-have-scanned-the-qr-code-and-enabled-google-authenticator")}}
        </label>

        <p v-if="showConfirmError" class="error-text">
          {{$t("Please confirm that you have scanned the QR code")}}
        </p>
      </div>

      <button class="verify-btn" @click="verifyOtp">
        {{$t("Submit")}}
      </button>

    </div>
  </div>
</template>

<script>
import axios from "axios"
import Cookies from "js-cookie"

export default {

  props:{
    visible:{
      type:Boolean,
      default:false
    }
  },

  data(){
    return{
      qrCodeStr:"",
      otp:"",
      isConfirmed:false,
      showConfirmError:false
    }
  },

  mounted(){
    this.loadQrCode()
  },

  methods:{

    loadQrCode(){
      const qr = localStorage.getItem("qr_code_str")
      // const user_id = localStorage.getItem("user_id");

      if(qr){
        if(qr.startsWith("data:image")){
          this.qrCodeStr = qr
        }else{
          this.qrCodeStr = "data:image/png;base64," + qr
        }
      }
    },

    filterNumeric(){
      this.otp = this.otp.replace(/[^0-9]/g,"")
    },

    clearOtp(){
      this.otp = ""
    },

    closeModal(){
      this.$emit("close")
    },

    async verifyOtp(){

      if(!this.isConfirmed){
        this.showConfirmError = true
        return
      }

      this.showConfirmError = false
      const qr = localStorage.getItem("qr_code_str")
      const user_id = localStorage.getItem("user_id");

      const requestData = {
        qr_code_str:qr,
        user_id : user_id,

      }

      const url = process.env.VUE_APP_API_URL + "accounts/enable_2fa/"
      // const url = "http://127.0.0.1:8000/api/accounts/enable_2fa/"

      try{

        const response = await axios.post(url, requestData)

          // Show success message
          this.$notify({
            group: "foo",
            text: this.$t("MFA Enabled Successfully, Please login again !"),
            type: "success",
            duration: 5000
          })

        const token = response.data.token

        Cookies.set("auth_token", token, {expires:7, secure:true})

        this.$emit("otpVerified",{otp:this.otp})
        localStorage.removeItem("qr_code_str")
        localStorage.removeItem("user_id")

      }
      catch(error){

        let err_msg = "MFA enabling failed, Please contact support !"

        if(error && error.response && error.response.data && error.response.data.error){
          err_msg = error.response.data.error
        }

        this.$notify({
          group:"foo",
          text:err_msg,
          type:"warn",
          duration:5000
        })

        this.clearOtp()

      }

    }

  }

}
</script>


<style scoped>

.otp-modal{
  position: fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background: rgba(0,0,0,0.5);
  display:flex;
  justify-content:center;
  align-items:center;
}

.otp-container{
  background:white;
  padding:30px;
  border-radius:8px;
  width:350px;
  text-align:center;
  position:relative;
}

.close-btn{
  position:absolute;
  top:10px;
  right:10px;
  background:none;
  border:none;
  cursor:pointer;
}

.qr-section{
  margin:20px 0;
  text-align:center;
}

.qr-image{
  width:200px;
  height:200px;
  margin:10px auto;
  display:block;
}

.verify-btn{
  margin-top:15px;
  width:100%;
  padding:10px;
  background:#007bff;
  color:white;
  border:none;
  border-radius:4px;
  cursor:pointer;
}

.checkbox-section{
  margin-top:15px;
  text-align:left;
  font-size:14px;
}

.checkbox-section input{
  margin-right:8px;
}

.verify-btn:disabled{
  background:#ccc;
  cursor:not-allowed;
}

.error-text{
  color:red;
  font-size:13px;
  margin-top:5px;
}
</style>
